
function AddTpa() {
    return (
        <div class="modal fade" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                        <h5 class="modal-title" id="exampleModalLabel">&nbsp;</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
                    </div>
                    <form class="tablelist-form" autocomplete="off">
                        <div class="modal-body">
                            <input id="id-field" type="hidden" />
                            <div class="row gy-4 mb-3">
                           
                                <div class="col-md-12">
                                    <div >
                                        <label for="customername-field" class="form-label">TPA Name</label>
                                        <input id="customername-field" class="form-control" placeholder="Enter TPA Name" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div >
                                        <label for="customername-field" class="form-label">Address</label>
                                        <input id="customername-field" class="form-control" placeholder="Enter Address" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div >
                                        <label for="customername-field" class="form-label">Phone Number</label>
                                        <input id="customername-field" class="form-control" placeholder="Enter Phone Number" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div >
                                        <label for="customername-field" class="form-label">TPA Person Name</label>
                                        <input id="customername-field" class="form-control" placeholder="Enter TPA Person Name" type="text" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="hstack gap-2 justify-content-end">
                                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-success" id="edit-btn">Add</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddTpa;
